import { LinkA, LinkImage, LinkText } from './styles';
import { Link } from '../../../types/subject';
import { useTheme } from '../../../hooks/useTheme';
import { hostMatches, safeWebURL } from '../../../utils/url';

interface LinkViewProps {
    link: Link;
}

const replacements = {
    "google.com": { name: "Search on\nGoogle", icon: "/assets/google_icon.png", iconDark: null },
    "amazon.com": { name: "Buy on\nAmazon", icon: "/assets/amazon_icon.png", iconDark: "/assets/amazon_icon_dark.png" },
    "wikipedia.org": { name: "Learn on\nWikipedia", icon: "/assets/wikipedia_icon.png", iconDark: "/assets/wikipedia_icon_dark.png" },
}

const LinkView: React.FC<LinkViewProps> = ({ link }) => {
    const isDarkMode = useTheme() === 'dark';

    // Links come from the AI output stored in Firestore: only render https ones
    const url = safeWebURL(link.url);
    if (!url) return null;

    // Brand by where the link actually goes, not by a substring of the URL
    const replacement = Object.entries(replacements).find(([domain]) => hostMatches(url, domain))?.[1];

    const name = replacement?.name ?? link.name;
    const icon = replacement
        ? (isDarkMode && replacement.iconDark) || replacement.icon
        : safeWebURL(link.icon)?.href;

    return (
        <LinkA target="_blank" rel="noopener noreferrer" href={url.href}>
            {icon && <LinkImage src={icon} alt="" />}
            <LinkText>{name}</LinkText>
        </LinkA>
    );
}

export default LinkView;
